export default function LangButton({
    color = 'white',
    label = 'EN',
    width = '32',
    height = '32',
}) {
    let colorText;
    let colorIcon;

    switch (color) {
        case 'gray':
            colorText = '#3D4A55';
            colorIcon = '#C1CED9';
            break;
        default:
            colorText = '#FFFFFF';
            colorIcon = '#222222';
            break;
    }

    return (
        <svg
            width={width + `px`}
            height={height + `px`}
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            xmlSpace="preserve"
        >
            <path
                fill={colorIcon}
                d="M452,128.9h-40v140.7c0,49.6-40.4,90-90,90H182.6l-14.8,8.5c6,26.8,30,46.9,58.5,46.9h111l93.6,53.5v-53.5h21
                                            c33.1,0,60-26.9,60-60v-166C512,155.8,485.1,128.9,452,128.9L452,128.9z"
            />
            <path
                fill={colorIcon}
                d="M322,329.6c33.1,0,60-26.9,60-60v-166c0-33.1-26.9-60-60-60H60c-33.1,0-60,26.9-60,60v166c0,33.1,26.9,60,60,60h21v53.5
                                            l93.6-53.5H322z"
            />
            <text
                transform="matrix(0.9761 0 0 1 64 253.3105)"
                className="st0 st1 st2"
                style={{
                    fill: colorText,
                    stroke: colorIcon,
                    strokeWidth: '0.75',
                    strokeMiterlimit: '10',
                    fontFamily: 'Arial-BoldMT, Arial, sans-serif',
                    fontSize: '185.1151px',
                }}
            >
                {label}
            </text>
        </svg>
    );
}

export { LangButton };
